/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { makeStyles } from 'tss-react/mui';

import { Theme } from '@mui/material/styles';

const ProfileViewStyles = makeStyles()((theme: Theme) => ({
	profileButton: {
		padding: '5px 5px !important',
		border: '1px solid rgba(0, 0, 0, 0.23) !important',
	},

	popover: {
		width: '300px',
	},

	container: {
		display: 'flex',
		justifyContent: 'flex-start',
	},

	imageContainer: {
		position: 'relative',
	},

	iconButton: {
		padding: 0,
		margin: '15px',
	},

	profileImage: {
		height: '50px',
		width: '50px',
		opacity: '75%',
		borderRadius: '50%',
	},

	profileImageIcon: {
		position: 'absolute',
		top: 'auto',
		bottom: 'auto',
	},

	username: {
		marginTop: 'auto',
		marginBottom: 'auto',
	},

	courseLeader: {
		color: theme.palette.grey['600'],
		fontSize: theme.typography.body2.fontSize,
	},

	editNameButton: {
		height: '14px',
		width: '14px',
	},

	nameContainer: {
		display: 'flex',
		justifyContent: 'center',
	},

	buttonContainer: {
		display: 'flex',
		justifyContent: 'center',
	},

	logout: {
		marginBottom: '15px',
		color: 'rgb(255, 69, 105) !important',
	},

	label: {
		justifyContent: 'flex-start',
		fontWeight: 'normal !important',
		fontSize: 'small !important',
	},

	textField: {
		width: '60%',
		'& .MuiInputBase-input': {
			fontSize: 'small',
			border: 'none !important',
			padding: '6px 0 7px 0 !important',
		},
	},

	input: {
		fontSize: 'small',
		border: 'none',
	},

	submitButton: {
		width: '40%',
	},
}));

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export default ProfileViewStyles;
